import { useAct } from 'FlowBuilder/store'
import useGenericTranslate from './useGenericTranslateFlow';
import { ActionTranslatableKeys, actionTranslatables } from 'FlowBuilder/lib/actionTranslatable';
import _ from 'lodash';

export default function useActionTranslate<T extends string | number | symbol = ActionTranslatableKeys>({ actionId, languageOverride = null } = {}) {
  if (!actionId) {
    throw new Error("useActionTranslate requires an actionId");
  }

  const act = useAct();
  const action = useSel((s) => {
    if (s.taker) {
      return _.find(s.taker.flow.actions, (a) => a.id === actionId)
    } else {
      return s.actions.entities[actionId]
    }
  })
  const textContent = action?.textContent || {}

  const {language, translated, fallback, flag} = useGenericTranslate<T>({ textContent, languageOverride, translatableConfiguration: actionTranslatables })

  function textContentUpdater(key: T, value: string) {
    act.actions.updateActionTextContent({ actionId: (actionId || action?.id), language, key, value })
  }

  return {
    language,
    translated,
    fallback,
    textContentUpdater,
    flag
  }
}
